import { APP_NAME } from '@shared/brand';

export function BrandLockup({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  return (
    <img
      src="/logo.png"
      alt={APP_NAME}
      className={`brand-lockup ${size}`}
    />
  );
}

export function BrandMark() {
  return <img src="/mark.png" alt="" className="brand-mark" />;
}
